<template>
  <div class="break-bar" :style="barStyle" :title="title" data-test-selector="break-bar" />
</template>

<script lang="ts">
import { Temporal } from '@js-temporal/polyfill'
import { useScheduleBarStyle } from '@/src/hooks/useScheduleBarStyle'
import { useTemporalPlainTime } from '@/src/hooks/useTemporalPlainTime'

export default defineComponent({
  name: 'BreakBar',
  props: {
    end: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
  },
  setup(props) {
    const midnight = computed(() => Temporal.PlainTime.from({ hour: 0, minute: 0, second: 0 }))
    const end = useTemporalPlainTime(toRef(props, 'end'))
    const barStyle = useScheduleBarStyle({ from: midnight, to: end })

    return {
      barStyle,
    }
  },
})
</script>

<style scoped lang="scss">
.break-bar {
  background-image: url('../../images/break_background.png');
  height: 100%;
  opacity: 0.8;
  position: absolute;

  &:hover {
    opacity: 0.5;
  }
}
</style>
